import { EmployeeActionType, Gender, OrderStatus, OrderType } from "./enums";

export class EmployeeFilterResource {
    pageIndex: number;
    orderBy: string;
    asc: boolean;
    keywords: string;
    firstName: string;
    lastName: string;
    organizationUnitId: number | null;
    employeeGroupId: number | null;
    employeePID: string;
    phone: string;
    employeeStatus: boolean | null;

    constructor() {
        this.pageIndex = 0;
        this.asc = false;
        this.orderBy = "";
        this.keywords = "";
        this.firstName = "";
        this.lastName = "";
        this.organizationUnitId = null;
        this.employeeGroupId = null;
        this.employeePID = "";
        this.phone = "";
        this.employeeStatus = null;
    }
}

export class Employee {
    id = 0;
    organizationUnit = "";
    employeeGroup = "";
    employeeNumber = "";
    employeePID = "";
    firstName = "";
    lastName = "";
    workPhone = "";
    mobilePhone = "";
    email = "";
    isActive = false;
    gender: Gender | null = null;
    workStartDate: string | null = "";
    workEndDate: string | null = "";
    username = "";
    usedBalance = 0;
    leftBalance = 0;
    defaultCurrencyId = 1;
    updatedAt = "";
    updatedByUser = "";
    quickAccessLink: string | null = null;
}

export class EditEmployeeRequest {
    id = 0;
    organizationUnitId = 0;
    employeeGroupId = 0;
    employeeNumber = "";
    employeePID = "";
    firstName = "";
    lastName = "";
    workPhone = "";
    mobilePhone = "";
    email = "";
    isActive = false;
    gender: Gender | null = null;
    workStartDate: string | null = "";
    workEndDate: string | null = "";
    username = "";
}

export interface EmployeeFilterResponse {
    total: number;
    totalFilter: number;
    hasNext: boolean;
    rows: Employee[];
}

export class CreateEmployeeRequest {
    organizationUnitId: string;
    employeeGroupId: string;
    employeeNumber: string;
    employeePID: string;
    firstName: string;
    lastName: string;
    workPhone: string;
    mobilePhone: string;
    email: string;
    isActive: boolean;
    gender: Gender;
    workStartDate: string | null;
    workEndDate: string | null;
    username: string;
    password: string | null;

    constructor() {
        this.organizationUnitId = "";
        this.employeeGroupId = "";
        this.employeeNumber = "";
        this.employeePID = "";
        this.firstName = "";
        this.lastName = "";
        this.workPhone = "";
        this.mobilePhone = "";
        this.email = "";
        this.isActive = false;
        this.gender = Gender.Male;
        this.workStartDate = "";
        this.workEndDate = "";
        this.username = "";
        this.password = null;
    }
}

export class EmployeeOrderResponse {
    id = 0;
    docket = "";
    externalSystem = "";
    status: OrderStatus = OrderStatus.None;
    type: OrderType = OrderType.WithoutSubsidy;
    total = 0;
    currencyId = 0;
    paidByWallet = 0;
    paidByEmployee = 0;
    createdAt = "";
    updatedAt = "";
    provider = "";
    subsidyAmount = 0;
}

export class EmployeeOrdersFilterRequest {
    employeeId = 0;
    keywords = "";
    fromDate: string | null = "";
    tillDate: string | null = "";
    orderStatus: OrderStatus | null = null;
    providerName: string | null = "";
    orderBy: string = "";
    asc: boolean = false;
    pageIndex = 0;
}

export interface EmployeeOrdersFilterResponse {
    hasNext: boolean;
    total: number;
    totalFilter: number;
    rows: EmployeeOrderResponse[];
}

export interface ExportEmployeeResponse {
    success: boolean;
    interfaceId: number;
}

export class EmployeeActionsRequest {
    filterRequest: EmployeeFilterResource | null = null;
    actionType: EmployeeActionType | null = null;
    checkAll: boolean = false;
    selectedEmployees: number[] = [];
    excludedEmployees: number[] = [];
}

export class EmployeeActionsResponse {
    updatedCount: number = 0;
}
